import { Controller } from "@hotwired/stimulus"

// Hides an element the user has dismissed, and keeps it hidden next time. The key says what
// was dismissed, for which month and at which 10% step of usage, so the same nudge returns when
// the month changes or usage climbs to the next step.
// localStorage is a per-viewer convenience here, so every access is allowed to fail.
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.#dismissed()) this.element.hidden = true
  }

  dismiss() {
    try { localStorage.setItem(this.keyValue, "1") } catch (e) { /* storage unavailable: just hide it for now */ }
    this.element.hidden = true
  }

  #dismissed() {
    try { return localStorage.getItem(this.keyValue) === "1" } catch (e) { return false }
  }
}
